import { toast } from "react-toastify";

export const notifyDemoAccountError = () => {
  toast.error(`You Are Using A Demo Account`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
  // dispatch(noError(""));
};
